"use client"
type Props = {
  title: string
  topTitle?: string
  children: any
}
const ContentCenter: React.FC<Props> = ({ title, topTitle, children }) => {
  return (
    <section className="join-moweb bg-grey section-py">
      <div className="container xl:container mx-auto">
        <div className="row flex justify-center">
          <div className="lg:w-8/12 px-1">
            <div className="Development-Services-head text-center">
              <p className="fw-700 fs-lg text-primary mb-2.5">{topTitle}</p>
              <h2 className="fw-700 fs-xl mb-2.5">{title}</h2>
              {children}
             
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContentCenter
